/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1);
	
	__webpack_require__(2);
	
	__webpack_require__(3);
	
	__webpack_require__(4);
	
	$(document).ready(function () {
	
	    //Product video popup
	    $('.video-trigger').click(function () {
	        $("body").addClass('video-active');
	        $(".video-container").css('z-index', '5');
	        $(".video-container").addClass("video-container--show");
	    });
	
	    var urlDump = $('#video').attr('src');
	    var url = $('#video').attr('src');
	
	    $('.video-trigger').click(function () {
	        $('#video').attr('src', urlDump);
	    });
	
	    $('.video-close').click(function () {
	        $('#video').attr('src', '');
	        $("body").removeClass('video-active');
	        $(".video-container").removeClass("video-container--show");
	        setTimeout(function () {
	            $(".video-container").css('z-index', '-2');
	        }, 300);
	    });
	
	    //sShorten footer contact info on mob
	    var headerLocation = $('.header__location');
	    var headerEmail = $('.header__email-text');
	
	    if ($(window).width() < 660) {
	        $('.contact_info--tel').text('Call Us');
	        $('.contact_info--email').text('Email Us');
	        headerLocation.text('Location');
	    }
	});

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	// Slider Starts
	$(document).ready(function () {
	    $('.slider').bxSlider({
	        auto: true,
	        autoStart: true,
	        autoDirection: 'next',
	        pager: true,
	        controls: true,
	        nextText: '',
	        prevText: ''
	    });
	    $('.slider__main').bxSlider({
	        auto: true,
	        autoStart: true,
	        autoDirection: 'next',
	        pager: true,
	        nextText: '',
	        prevText: ''
	    });
	});
	// Slider Ends

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*
	 * priority-nav - v1.0.12 | (c) 2016 @gijsroge | MIT license
	 * Repository: https://github.com/gijsroge/priority-navigation.git
	 * Description: Priority+ pattern navigation that hides menu items if they don't fit on screen.
	 * Demo: http://gijsroge.github.io/priority-nav.js/
	 */
	(function (root, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory(root)), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === "object") {
	        module.exports = factory(root);
	    } else {
	        root.priorityNav = factory(root);
	    }
	})(window || undefined, function (root) {
	
	    "use strict";
	
	    /**
	     * Variables
	     */
	
	    var priorityNav = {}; // Object for public APIs
	    var breaks = []; // Object to store instances with breakpoints where the instances menu item"s didin"t fit.
	    var supports = !!document.querySelector && !!root.addEventListener; // Feature test
	    var settings = {};
	    var instance = 0;
	    var count = 0;
	    var mainNavWrapper, totalWidth, restWidth, mainNav, navDropdown, navDropdownToggle, dropDownWidth, toggleWrapper;
	    var viewportWidth = 0;
	
	    /**
	     * Default settings
	     * @type {{initClass: string, navDropdown: string, navDropdownToggle: string, mainNavWrapper: string, moved: Function, movedBack: Function}}
	     */
	    var defaults = {
	        initClass: "js-priorityNav", // Class that will be printed on html element to allow conditional css styling.
	        mainNavWrapper: "nav", // mainnav wrapper selector (must be direct parent from mainNav)
	        mainNav: "ul", // mainnav selector. (must be inline-block)
	        navDropdownClassName: "nav__dropdown", // class used for the dropdown.
	        navDropdownToggleClassName: "nav__dropdown-toggle", // class used for the dropdown toggle.
	        navDropdownLabel: "more", // Text that is used for the dropdown toggle.
	        navDropdownBreakpointLabel: "menu", //button label for navDropdownToggle when the breakPoint is reached.
	        breakPoint: 500, //amount of pixels when all menu items should be moved to dropdown to simulate a mobile menu
	        throttleDelay: 50, // this will throttle the calculating logic on resize because i'm a responsible dev.
	        offsetPixels: 0, // increase to decrease the time it takes to move an item.
	        count: true, // prints the amount of items are moved to the attribute data-count to style with css counter.
	
	        //Callbacks
	        moved: function moved() {},
	        movedBack: function movedBack() {}
	    };
	
	    /**
	     * A simple forEach() implementation for Arrays, Objects and NodeLists
	     * @private
	     * @param {Array|Object|NodeList} collection Collection of items to iterate
	     * @param {Function} callback Callback function for each iteration
	     * @param {Array|Object|NodeList} scope Object/NodeList/Array that forEach is iterating over (aka `this`)
	     */
	    var forEach = function forEach(collection, callback, scope) {
	        if (Object.prototype.toString.call(collection) === "[object Object]") {
	            for (var prop in collection) {
	                if (Object.prototype.hasOwnProperty.call(collection, prop)) {
	                    callback.call(scope, collection[prop], prop, collection);
	                }
	            }
	        } else {
	            for (var i = 0, len = collection.length; i < len; i++) {
	                callback.call(scope, collection[i], i, collection);
	            }
	        }
	    };
	
	    /**
	     * Get the closest matching element up the DOM tree
	     * @param {Element} elem Starting element
	     * @param {String} selector Selector to match against (class, ID, or data attribute)
	     * @return {Boolean|Element} Returns false if not match found
	     */
	    var getClosest = function getClosest(elem, selector) {
	        var firstChar = selector.charAt(0);
	        for (; elem && elem !== document; elem = elem.parentNode) {
	            if (firstChar === ".") {
	                if (elem.classList.contains(selector.substr(1))) {
	                    return elem;
	                }
	            } else if (firstChar === "#") {
	                if (elem.id === selector.substr(1)) {
	                    return elem;
	                }
	            } else if (firstChar === "[") {
	                if (elem.hasAttribute(selector.substr(1, selector.length - 2))) {
	                    return elem;
	                }
	            }
	        }
	        return false;
	    };
	
	    /**
	     * Merge defaults with user options
	     * @private
	     * @param {Object} defaults Default settings
	     * @param {Object} options User options
	     * @returns {Object} Merged values of defaults and options
	     */
	    var extend = function extend(defaults, options) {
	        var extended = {};
	        forEach(defaults, function (value, prop) {
	            extended[prop] = defaults[prop];
	        });
	        forEach(options, function (value, prop) {
	            extended[prop] = options[prop];
	        });
	        return extended;
	    };
	
	    /**
	     * Debounced resize to throttle execution
	     * @param func
	     * @param wait
	     * @param immediate
	     * @returns {Function}
	     */
	    function debounce(func, wait, immediate) {
	        var timeout;
	        return function () {
	            var context = this,
	                args = arguments;
	            var later = function later() {
	                timeout = null;
	                if (!immediate) func.apply(context, args);
	            };
	            var callNow = immediate && !timeout;
	            clearTimeout(timeout);
	            timeout = setTimeout(later, wait);
	            if (callNow) func.apply(context, args);
	        };
	    }
	
	    /**
	     * Toggle class on element
	     * @param el
	     * @param className
	     */
	    var toggleClass = function toggleClass(el, className) {
	        if (el.classList) {
	            el.classList.toggle(className);
	        } else {
	            var classes = el.className.split(" ");
	            var existingIndex = classes.indexOf(className);
	
	            if (existingIndex >= 0) classes.splice(existingIndex, 1);else classes.push(className);
	
	            el.className = classes.join(" ");
	        }
	    };
	
	    /**
	     * Check if dropdown menu is already on page before creating it
	     * @param mainNavWrapper
	     */
	    var prepareHtml = function prepareHtml(_this, settings) {
	
	        /**
	         * Create dropdow menu
	         * @type {HTMLElement}
	         */
	        toggleWrapper = document.createElement("span");
	        navDropdown = document.createElement("ul");
	        navDropdownToggle = document.createElement("button");
	
	        /**
	         * Set label for dropdown toggle
	         * @type {string}
	         */
	        navDropdownToggle.innerHTML = settings.navDropdownLabel;
	
	        /**
	         * Set aria attributes for accessibility
	         */
	        navDropdownToggle.setAttribute("aria-controls", "menu");
	        navDropdownToggle.setAttribute("type", "button");
	        navDropdown.setAttribute("aria-hidden", "true");
	
	        /**
	         * Move elements to the right spot
	         */
	        if (_this.querySelector(mainNav).parentNode !== _this) {
	            console.warn("mainNav is not a direct child of mainNavWrapper, double check please");
	            return;
	        }
	
	        _this.insertAfter(toggleWrapper, _this.querySelector(mainNav));
	
	        toggleWrapper.appendChild(navDropdownToggle);
	        toggleWrapper.appendChild(navDropdown);
	
	        /**
	         * Add classes so we can target elements
	         */
	        navDropdown.classList.add(settings.navDropdownClassName);
	        navDropdown.classList.add("priority-nav__dropdown");
	
	        navDropdownToggle.classList.add(settings.navDropdownToggleClassName);
	        navDropdownToggle.classList.add("priority-nav__dropdown-toggle");
	
	        toggleWrapper.classList.add(settings.navDropdownClassName + "-wrapper");
	        toggleWrapper.classList.add("priority-nav__wrapper");
	
	        _this.classList.add("priority-nav");
	    };
	
	    /**
	     * Get innerwidth without padding
	     * @param element
	     * @returns {number}
	     */
	    var getElementContentWidth = function getElementContentWidth(element) {
	        var styles = window.getComputedStyle(element);
	        var padding = parseFloat(styles.paddingLeft) + parseFloat(styles.paddingRight);
	
	        return element.clientWidth - padding;
	    };
	
	    /**
	     * Get viewport size
	     * @returns {{width: number, height: number}}
	     */
	    var viewportSize = function viewportSize() {
	        var doc = document,
	            w = window;
	        var docEl = doc.compatMode && doc.compatMode === "CSS1Compat" ? doc.documentElement : doc.body;
	
	        var width = docEl.clientWidth;
	        var height = docEl.clientHeight;
	
	        // mobile zoomed in?
	        if (w.innerWidth && width > w.innerWidth) {
	            width = w.innerWidth;
	            height = w.innerHeight;
	        }
	
	        return { width: width, height: height };
	    };
	
	    /**
	     * Get width
	     * @param elem
	     * @returns {number}
	     */
	    var calculateWidths = function calculateWidths(_this) {
	        totalWidth = getElementContentWidth(_this);
	        //Check if parent is the navwrapper before calculating its width
	        if (_this.querySelector(navDropdown).parentNode === _this) {
	            dropDownWidth = _this.querySelector(navDropdown).offsetWidth;
	        } else {
	            dropDownWidth = 0;
	        }
	        restWidth = getChildrenWidth(_this) + settings.offsetPixels;
	        viewportWidth = viewportSize().width;
	    };
	
	    /**
	     * Move item to array
	     * @param item
	     */
	    priorityNav.doesItFit = function (_this) {
	
	        /**
	         * Check if it is the first run
	         */
	        var delay = _this.getAttribute("instance") === 0 ? delay : settings.throttleDelay;
	
	        /**
	         * Increase instance
	         */
	        instance++;
	
	        /**
	         * Debounced execution of the main logic
	         */
	        debounce(function () {
	
	            /**
	             * Get the current element"s instance
	             * @type {string}
	             */
	            var identifier = _this.getAttribute("instance");
	
	            /**
	             * Update width
	             */
	            calculateWidths(_this);
	
	            /**
	             * Keep executing until all menu items that are overflowing are moved
	             */
	            while (totalWidth <= restWidth && _this.querySelector(mainNav).children.length > 0 || viewportWidth < settings.breakPoint && _this.querySelector(mainNav).children.length > 0) {
	                //move item to dropdown
	                $('.priority-nav-is-visible').css('display', 'inline-block');
	                priorityNav.toDropdown(_this, identifier);
	                //recalculate widths
	                calculateWidths(_this, identifier);
	                //update dropdownToggle label
	                if (viewportWidth < settings.breakPoint) updateLabel(_this, identifier, settings.navDropdownBreakpointLabel);
	            }
	
	            /**
	             * Keep executing until all menu items that are able to move back are moved
	             */
	            while (totalWidth >= breaks[identifier][breaks[identifier].length - 1] && viewportWidth > settings.breakPoint) {
	                //move item to menu
	                priorityNav.toMenu(_this, identifier);
	                //update dropdownToggle label
	                if (viewportWidth > settings.breakPoint) updateLabel(_this, identifier, settings.navDropdownLabel);
	            }
	
	            /**
	             * If there are no items in dropdown hide dropdown
	             */
	            if (breaks[identifier].length < 1) {
	                _this.querySelector(navDropdown).classList.remove("show");
	                //show navDropdownLabel
	                updateLabel(_this, identifier, settings.navDropdownLabel);
	            }
	
	            /**
	             * If there are no items in menu
	             */
	            if (_this.querySelector(mainNav).children.length < 1) {
	                //show navDropdownBreakpointLabel
	                _this.classList.add("is-empty");
	                updateLabel(_this, identifier, settings.navDropdownBreakpointLabel);
	            } else {
	                _this.classList.remove("is-empty");
	            }
	
	            /**
	             * Check if we need to show toggle menu button
	             */
	            showToggle(_this, identifier);
	        }, delay)();
	    };
	
	    /**
	     * Show/hide toggle button
	     */
	    var showToggle = function showToggle(_this, identifier) {
	        if (breaks[identifier].length < 1) {
	            _this.querySelector(navDropdownToggle).classList.add("priority-nav-is-hidden");
	            _this.querySelector(navDropdownToggle).classList.remove("priority-nav-is-visible");
	            _this.classList.remove("priority-nav-has-dropdown");
	
	            /**
	             * Set aria attributes for accessibility
	             */
	            _this.querySelector(".priority-nav__wrapper").setAttribute("aria-haspopup", "false");
	        } else {
	            _this.querySelector(navDropdownToggle).classList.add("priority-nav-is-visible");
	            _this.querySelector(navDropdownToggle).classList.remove("priority-nav-is-hidden");
	            _this.classList.add("priority-nav-has-dropdown");
	
	            /**
	             * Set aria attributes for accessibility
	             */
	            _this.querySelector(".priority-nav__wrapper").setAttribute("aria-haspopup", "true");
	        }
	    };
	
	    /**
	     * Update count on dropdown toggle button
	     */
	    var updateCount = function updateCount(_this, identifier) {
	        _this.querySelector(navDropdownToggle).setAttribute("priorityNav-count", breaks[identifier].length);
	    };
	
	    var updateLabel = function updateLabel(_this, identifier, label) {
	        _this.querySelector(navDropdownToggle).innerHTML = label;
	    };
	
	    /**
	     * Move item to dropdown
	     */
	    priorityNav.toDropdown = function (_this, identifier) {
	
	        /**
	         * move last child of navigation menu to dropdown
	         */
	        if (_this.querySelector(navDropdown).firstChild && _this.querySelector(mainNav).children.length > 0) {
	            _this.querySelector(navDropdown).insertBefore(_this.querySelector(mainNav).lastElementChild, _this.querySelector(navDropdown).firstChild);
	        } else if (_this.querySelector(mainNav).children.length > 0) {
	            _this.querySelector(navDropdown).appendChild(_this.querySelector(mainNav).lastElementChild);
	        }
	
	        /**
	         * store breakpoints
	         */
	        breaks[identifier].push(restWidth);
	
	        /**
	         * check if we need to show toggle menu button
	         */
	        showToggle(_this, identifier);
	
	        /**
	         * update count on dropdown toggle button
	         */
	        if (_this.querySelector(mainNav).children.length > 0 && settings.count) {
	            updateCount(_this, identifier);
	        }
	
	        /**
	         * If item has been moved to dropdown trigger the callback
	         */
	        settings.moved();
	    };
	
	    /**
	     * Move item to menu
	     */
	    priorityNav.toMenu = function (_this, identifier) {
	
	        /**
	         * move last child of navigation menu to dropdown
	         */
	        if (_this.querySelector(navDropdown).children.length > 0) _this.querySelector(mainNav).appendChild(_this.querySelector(navDropdown).firstElementChild);
	
	        /**
	         * remove last breakpoint
	         */
	        breaks[identifier].pop();
	
	        /**
	         * Check if we need to show toggle menu button
	         */
	        showToggle(_this, identifier);
	
	        /**
	         * update count on dropdown toggle button
	         */
	        if (_this.querySelector(mainNav).children.length > 0 && settings.count) {
	            updateCount(_this, identifier);
	        }
	
	        /**
	         * If item has been moved back to the main menu trigger the callback
	         */
	        settings.movedBack();
	    };
	
	    /**
	     * Count width of children and return the value
	     * @param e
	     */
	    var getChildrenWidth = function getChildrenWidth(e) {
	        var children = e.childNodes;
	        var sum = 0;
	        for (var i = 0; i < children.length; i++) {
	            if (children[i].nodeType !== 3) {
	                if (!isNaN(children[i].offsetWidth)) {
	                    sum += children[i].offsetWidth;
	                }
	            }
	        }
	        return sum;
	    };
	
	    /**
	     * Bind eventlisteners
	     */
	    var listeners = function listeners(_this, settings) {
	
	        // Check if an item needs to move
	        if (window.attachEvent) {
	            window.attachEvent("onresize", function () {
	                if (priorityNav.doesItFit) priorityNav.doesItFit(_this);
	            });
	        } else if (window.addEventListener) {
	            window.addEventListener("resize", function () {
	                if (priorityNav.doesItFit) priorityNav.doesItFit(_this);
	            }, true);
	        }
	
	        // Toggle dropdown
	        _this.querySelector(navDropdownToggle).addEventListener("click", function () {
	            toggleClass(_this.querySelector(navDropdown), "show");
	            toggleClass(this, "is-open");
	            toggleClass(_this, "is-open");
	
	            /**
	             * Toggle aria hidden for accessibility
	             */
	            if (-1 !== _this.className.indexOf("is-open")) {
	                _this.querySelector(navDropdown).setAttribute("aria-hidden", "false");
	            } else {
	                _this.querySelector(navDropdown).setAttribute("aria-hidden", "true");
	                _this.querySelector(navDropdown).blur();
	            }
	        });
	
	        /*
	         * Remove when clicked outside dropdown
	         */
	        document.addEventListener("click", function (event) {
	            if (!getClosest(event.target, "." + settings.navDropdownClassName) && event.target !== _this.querySelector(navDropdownToggle)) {
	                _this.querySelector(navDropdown).classList.remove("show");
	                _this.querySelector(navDropdownToggle).classList.remove("is-open");
	                _this.classList.remove("is-open");
	            }
	        });
	
	        /**
	         * Remove when escape key is pressed
	         */
	        document.onkeydown = function (evt) {
	            evt = evt || window.event;
	            if (evt.keyCode === 27) {
	                document.querySelector(navDropdown).classList.remove("show");
	                document.querySelector(navDropdownToggle).classList.remove("is-open");
	                mainNavWrapper.classList.remove("is-open");
	            }
	        };
	    };
	
	    /**
	     * Remove function
	     */
	    Element.prototype.remove = function () {
	        this.parentElement.removeChild(this);
	    };
	
	    /*global HTMLCollection */
	    NodeList.prototype.remove = HTMLCollection.prototype.remove = function () {
	        for (var i = 0, len = this.length; i < len; i++) {
	            if (this[i] && this[i].parentElement) {
	                this[i].parentElement.removeChild(this[i]);
	            }
	        }
	    };
	
	    /**
	     * Destroy the current initialization.
	     * @public
	     */
	    priorityNav.destroy = function () {
	        // If plugin isn"t already initialized, stop
	        if (!settings) return;
	        // Remove feedback class
	        document.documentElement.classList.remove(settings.initClass);
	        // Remove toggle
	        toggleWrapper.remove();
	        // Remove settings
	        settings = null;
	        delete priorityNav.init;
	        delete priorityNav.doesItFit;
	    };
	
	    /**
	     * insertAfter function
	     * @param n
	     * @param r
	     */
	    if (supports && typeof Node !== "undefined") {
	        Node.prototype.insertAfter = function (n, r) {
	            this.insertBefore(n, r.nextSibling);
	        };
	    }
	
	    var checkForSymbols = function checkForSymbols(string) {
	        var firstChar = string.charAt(0);
	        if (firstChar === "." || firstChar === "#") {
	            return false;
	        } else {
	            return true;
	        }
	    };
	
	    /**
	     * Initialize Plugin
	     * @public
	     * @param {Object} options User settings
	     */
	    priorityNav.init = function (options) {
	
	        /**
	         * Merge user options with defaults
	         * @type {Object}
	         */
	        settings = extend(defaults, options || {});
	
	        // Feature test.
	        if (!supports && typeof Node === "undefined") {
	            console.warn("This browser doesn't support priorityNav");
	            return;
	        }
	
	        // Options check
	        if (!checkForSymbols(settings.navDropdownClassName) || !checkForSymbols(settings.navDropdownToggleClassName)) {
	            console.warn("No symbols allowed in navDropdownClassName & navDropdownToggleClassName. These are not selectors.");
	            return;
	        }
	
	        /**
	         * Store nodes
	         * @type {NodeList}
	         */
	        var elements = document.querySelectorAll(settings.mainNavWrapper);
	
	        /**
	         * Loop over every instance and reference _this
	         */
	        forEach(elements, function (_this) {
	
	            /**
	             * Create breaks array
	             * @type {number}
	             */
	            breaks[count] = [];
	
	            /**
	             * Set the instance number as data attribute
	             */
	            _this.setAttribute("instance", count++);
	
	            /**
	             * Store the wrapper element
	             */
	            mainNavWrapper = _this;
	            if (!mainNavWrapper) {
	                console.warn("couldn't find the specified mainNavWrapper element");
	                return;
	            }
	
	            /**
	             * Store the menu elementStore the menu element
	             */
	            mainNav = settings.mainNav;
	            if (!_this.querySelector(mainNav)) {
	                console.warn("couldn't find the specified mainNav element");
	                return;
	            }
	
	            /**
	             * Check if we need to create the dropdown elements
	             */
	            prepareHtml(_this, settings);
	
	            /**
	             * Store the dropdown element
	             */
	            navDropdown = "." + settings.navDropdownClassName;
	            if (!_this.querySelector(navDropdown)) {
	                console.warn("couldn't find the specified navDropdown element");
	                return;
	            }
	
	            /**
	             * Store the dropdown toggle element
	             */
	            navDropdownToggle = "." + settings.navDropdownToggleClassName;
	            if (!_this.querySelector(navDropdownToggle)) {
	                console.warn("couldn't find the specified navDropdownToggle element");
	                return;
	            }
	
	            /**
	             * Event listeners
	             */
	            listeners(_this, settings);
	
	            /**
	             * Start first check
	             */
	            priorityNav.doesItFit(_this);
	        });
	
	        /**
	         * Count amount of instances
	         */
	        instance++;
	
	        /**
	         * Add class to HTML element to activate conditional CSS
	         */
	        document.documentElement.classList.add(settings.initClass);
	    };
	
	    /**
	     * Public APIs
	     */
	    return priorityNav;
	});

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	'use strict';
	
	$(document).ready(function () {
	    // Mobile Navigation
	    var navContainer = $('.mobile__nav');
	    var menuBtn = $('.mobile__menuIcon');
	
	    menuBtn.click(function () {
	        menuBtn.toggleClass('open');
	        navContainer.slideToggle();
	        $("body").toggleClass('no-scroll');
	    });
	
	    $(window).resize(function () {
	        // Mobile Menu
	        if ($(window).width() >= 768) {
	            $('.mobile__nav').hide();
	            menuBtn.removeClass('open');
	        }
	    });
	
	    if ($(window).width() >= 768) {
	        $('.mobile__nav').hide();
	    }
	
	    // Create Arrow Per Drop Down
	
	    $('.menu-item-has-children > a').append('<div class="mobile__arrow"></div>');
	
	    // And for priority nav MORE
	    $('.priority-nav__wrapper').append('<div class="mobile__arrow"></div>');
	
	    $('.nav__dropdown-toggle').click(function () {
	        $('.sub-menu').closest().hide();
	
	        var mobileArrows = $('.mobile__arrow');
	
	        if (mobileArrows.hasClass('active')) {
	            mobileArrows.removeClass('active');
	        }
	
	        if (mobileArrows.hasClass('mobile__arrow--active')) {
	            mobileArrows.removeClass('mobile__arrow--active');
	        }
	    });
	
	    // Event Delegation for nav dropdowns for tablet/mobile
	    function addClickForDropdowns() {
	        $('body').click(function (e) {
	
	            // Click handler for stories link on archive page
	            if (e.target && e.target.matches('div') && e.target.matches('div.mobile__arrow') && $(e.target).closest('.mobile__nav').hasClass('mobile__nav')) {
	                e.stopPropagation();
	                e.preventDefault();
	
	                e.target.classList.toggle('mobile__arrow--active');
	
	                if (e.target.parentNode.parentNode.classList.contains('nav-item__active')) {
	                    e.target.parentNode.parentNode.classList.remove('nav-item__active');
	                } else {
	                    e.target.parentNode.parentNode.classList.add('nav-item__active');
	                }
	
	                // e.target.parentNode.parentNode.querySelector(':scope > .sub-menu').classList.toggle('sub-menu--active');
	                $(e.target).closest('.menu-item').find('.sub-menu').slideToggle();
	            } else {
	                // Else remove active nav states
	                $('.menu-item-has-children').removeClass('nav-item__active');
	                $('.sub-menu').removeClass('sub-menu--active');
	                $('.mobile__arrow').removeClass('mobile__arrow--active');
	            }
	        });
	    }
	
	    addClickForDropdowns();
	});

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * BxSlider v4.1.2 - Fully loaded, responsive content slider
	 * http://bxslider.com
	 *
	 * Copyright 2014, Steven Wanderski - http://stevenwanderski.com - http://bxcreative.com
	 * Written while drinking Belgian ales and listening to jazz
	 *
	 * Released under the MIT license - http://opensource.org/licenses/MIT
	 */
	!function (t) {
	  var e = {},
	      s = { mode: "horizontal", slideSelector: "", infiniteLoop: !0, hideControlOnEnd: !1, speed: 500, easing: null, slideMargin: 0, startSlide: 0, randomStart: !1, captions: !1, ticker: !1, tickerHover: !1, adaptiveHeight: !1, adaptiveHeightSpeed: 500, video: !1, useCSS: !0, preloadImages: "visible", responsive: !0, slideZIndex: 50, touchEnabled: !0, swipeThreshold: 50, oneToOneTouch: !0, preventDefaultSwipeX: !0, preventDefaultSwipeY: !1, pager: !0, pagerType: "full", pagerShortSeparator: " / ", pagerSelector: null, buildPager: null, pagerCustom: null, controls: !0, nextText: "Next", prevText: "Prev", nextSelector: null, prevSelector: null, autoControls: !1, startText: "Start", stopText: "Stop", autoControlsCombine: !1, autoControlsSelector: null, auto: !1, pause: 4e3, autoStart: !0, autoDirection: "next", autoHover: !1, autoDelay: 0, minSlides: 1, maxSlides: 1, moveSlides: 0, slideWidth: 0, onSliderLoad: function onSliderLoad() {}, onSlideBefore: function onSlideBefore() {}, onSlideAfter: function onSlideAfter() {}, onSlideNext: function onSlideNext() {}, onSlidePrev: function onSlidePrev() {}, onSliderResize: function onSliderResize() {} };t.fn.bxSlider = function (n) {
	    if (0 == this.length) return this;if (this.length > 1) return this.each(function () {
	      t(this).bxSlider(n);
	    }), this;var o = {},
	        r = this;e.el = this;var a = t(window).width(),
	        l = t(window).height(),
	        d = function d() {
	      o.settings = t.extend({}, s, n), o.settings.slideWidth = parseInt(o.settings.slideWidth), o.children = r.children(o.settings.slideSelector), o.children.length < o.settings.minSlides && (o.settings.minSlides = o.children.length), o.children.length < o.settings.maxSlides && (o.settings.maxSlides = o.children.length), o.settings.randomStart && (o.settings.startSlide = Math.floor(Math.random() * o.children.length)), o.active = { index: o.settings.startSlide }, o.carousel = o.settings.minSlides > 1 || o.settings.maxSlides > 1, o.carousel && (o.settings.preloadImages = "all"), o.minThreshold = o.settings.minSlides * o.settings.slideWidth + (o.settings.minSlides - 1) * o.settings.slideMargin, o.maxThreshold = o.settings.maxSlides * o.settings.slideWidth + (o.settings.maxSlides - 1) * o.settings.slideMargin, o.working = !1, o.controls = {}, o.interval = null, o.animProp = "vertical" == o.settings.mode ? "top" : "left", o.usingCSS = o.settings.useCSS && "fade" != o.settings.mode && function () {
	        var t = document.createElement("div"),
	            e = ["WebkitPerspective", "MozPerspective", "OPerspective", "msPerspective"];for (var i in e) {
	          if (void 0 !== t.style[e[i]]) return o.cssPrefix = e[i].replace("Perspective", "").toLowerCase(), o.animProp = "-" + o.cssPrefix + "-transform", !0;
	        }return !1;
	      }(), "vertical" == o.settings.mode && (o.settings.maxSlides = o.settings.minSlides), r.data("origStyle", r.attr("style")), r.children(o.settings.slideSelector).each(function () {
	        t(this).data("origStyle", t(this).attr("style"));
	      }), c();
	    },
	        c = function c() {
	      r.wrap('<div class="bx-wrapper"><div class="bx-viewport"></div></div>'), o.viewport = r.parent(), o.loader = t('<div class="bx-loading" />'), o.viewport.prepend(o.loader), r.css({ width: "horizontal" == o.settings.mode ? 100 * o.children.length + 215 + "%" : "auto", position: "relative" }), o.usingCSS && o.settings.easing ? r.css("-" + o.cssPrefix + "-transition-timing-function", o.settings.easing) : o.settings.easing || (o.settings.easing = "swing"), f(), o.viewport.css({ width: "100%", overflow: "hidden", position: "relative" }), o.viewport.parent().css({ maxWidth: p() }), o.settings.pager || o.viewport.parent().css({ margin: "0 auto 0px" }), o.children.css({ "float": "horizontal" == o.settings.mode ? "left" : "none", listStyle: "none", position: "relative" }), o.children.css("width", u()), "horizontal" == o.settings.mode && o.settings.slideMargin > 0 && o.children.css("marginRight", o.settings.slideMargin), "vertical" == o.settings.mode && o.settings.slideMargin > 0 && o.children.css("marginBottom", o.settings.slideMargin), "fade" == o.settings.mode && (o.children.css({ position: "absolute", zIndex: 0, display: "none" }), o.children.eq(o.settings.startSlide).css({ zIndex: o.settings.slideZIndex, display: "block" })), o.controls.el = t('<div class="bx-controls" />'), o.settings.captions && P(), o.active.last = o.settings.startSlide == x() - 1, o.settings.video && r.fitVids();var e = o.children.eq(o.settings.startSlide);"all" == o.settings.preloadImages && (e = o.children), o.settings.ticker ? o.settings.pager = !1 : (o.settings.pager && T(), o.settings.controls && C(), o.settings.auto && o.settings.autoControls && E(), (o.settings.controls || o.settings.autoControls || o.settings.pager) && o.viewport.after(o.controls.el)), g(e, h);
	    },
	        g = function g(e, i) {
	      var s = e.find("img, iframe").length;if (0 == s) return i(), void 0;var n = 0;e.find("img, iframe").each(function () {
	        t(this).one("load", function () {
	          ++n == s && i();
	        }).each(function () {
	          this.complete && t(this).load();
	        });
	      });
	    },
	        h = function h() {
	      if (o.settings.infiniteLoop && "fade" != o.settings.mode && !o.settings.ticker) {
	        var e = "vertical" == o.settings.mode ? o.settings.minSlides : o.settings.maxSlides,
	            i = o.children.slice(0, e).clone().addClass("bx-clone"),
	            s = o.children.slice(-e).clone().addClass("bx-clone");r.append(i).prepend(s);
	      }o.loader.remove(), S(), "vertical" == o.settings.mode && (o.settings.adaptiveHeight = !0), o.viewport.height(v()), r.redrawSlider(), o.settings.onSliderLoad(o.active.index), o.initialized = !0, o.settings.responsive && t(window).bind("resize", Z), o.settings.auto && o.settings.autoStart && H(), o.settings.ticker && L(), o.settings.pager && q(o.settings.startSlide), o.settings.controls && W(), o.settings.touchEnabled && !o.settings.ticker && O();
	    },
	        v = function v() {
	      var e = 0,
	          s = t();if ("vertical" == o.settings.mode || o.settings.adaptiveHeight) {
	        if (o.carousel) {
	          var n = 1 == o.settings.moveSlides ? o.active.index : o.active.index * m();for (s = o.children.eq(n), i = 1; i <= o.settings.maxSlides - 1; i++) {
	            s = n + i >= o.children.length ? s.add(o.children.eq(i - 1)) : s.add(o.children.eq(n + i));
	          }
	        } else s = o.children.eq(o.active.index);
	      } else s = o.children;return "vertical" == o.settings.mode ? (s.each(function () {
	        e += t(this).outerHeight();
	      }), o.settings.slideMargin > 0 && (e += o.settings.slideMargin * (o.settings.minSlides - 1))) : e = Math.max.apply(Math, s.map(function () {
	        return t(this).outerHeight(!1);
	      }).get()), e;
	    },
	        p = function p() {
	      var t = "100%";return o.settings.slideWidth > 0 && (t = "horizontal" == o.settings.mode ? o.settings.maxSlides * o.settings.slideWidth + (o.settings.maxSlides - 1) * o.settings.slideMargin : o.settings.slideWidth), t;
	    },
	        u = function u() {
	      var t = o.settings.slideWidth,
	          e = o.viewport.width();return 0 == o.settings.slideWidth || o.settings.slideWidth > e && !o.carousel || "vertical" == o.settings.mode ? t = e : o.settings.maxSlides > 1 && "horizontal" == o.settings.mode && (e > o.maxThreshold || e < o.minThreshold && (t = (e - o.settings.slideMargin * (o.settings.minSlides - 1)) / o.settings.minSlides)), t;
	    },
	        f = function f() {
	      var t = 1;if ("horizontal" == o.settings.mode && o.settings.slideWidth > 0) {
	        if (o.viewport.width() < o.minThreshold) t = o.settings.minSlides;else if (o.viewport.width() > o.maxThreshold) t = o.settings.maxSlides;else {
	          var e = o.children.first().width();t = Math.floor(o.viewport.width() / e);
	        }
	      } else "vertical" == o.settings.mode && (t = o.settings.minSlides);return t;
	    },
	        x = function x() {
	      var t = 0;if (o.settings.moveSlides > 0) {
	        if (o.settings.infiniteLoop) t = o.children.length / m();else for (var e = 0, i = 0; e < o.children.length;) {
	          ++t, e = i + f(), i += o.settings.moveSlides <= f() ? o.settings.moveSlides : f();
	        }
	      } else t = Math.ceil(o.children.length / f());return t;
	    },
	        m = function m() {
	      return o.settings.moveSlides > 0 && o.settings.moveSlides <= f() ? o.settings.moveSlides : f();
	    },
	        S = function S() {
	      if (o.children.length > o.settings.maxSlides && o.active.last && !o.settings.infiniteLoop) {
	        if ("horizontal" == o.settings.mode) {
	          var t = o.children.last(),
	              e = t.position();b(-(e.left - (o.viewport.width() - t.width())), "reset", 0);
	        } else if ("vertical" == o.settings.mode) {
	          var i = o.children.length - o.settings.minSlides,
	              e = o.children.eq(i).position();b(-e.top, "reset", 0);
	        }
	      } else {
	        var e = o.children.eq(o.active.index * m()).position();o.active.index == x() - 1 && (o.active.last = !0), void 0 != e && ("horizontal" == o.settings.mode ? b(-e.left, "reset", 0) : "vertical" == o.settings.mode && b(-e.top, "reset", 0));
	      }
	    },
	        b = function b(t, e, i, s) {
	      if (o.usingCSS) {
	        var n = "vertical" == o.settings.mode ? "translate3d(0, " + t + "px, 0)" : "translate3d(" + t + "px, 0, 0)";r.css("-" + o.cssPrefix + "-transition-duration", i / 1e3 + "s"), "slide" == e ? (r.css(o.animProp, n), r.bind("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd", function () {
	          r.unbind("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd"), D();
	        })) : "reset" == e ? r.css(o.animProp, n) : "ticker" == e && (r.css("-" + o.cssPrefix + "-transition-timing-function", "linear"), r.css(o.animProp, n), r.bind("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd", function () {
	          r.unbind("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd"), b(s.resetValue, "reset", 0), N();
	        }));
	      } else {
	        var a = {};a[o.animProp] = t, "slide" == e ? r.animate(a, i, o.settings.easing, function () {
	          D();
	        }) : "reset" == e ? r.css(o.animProp, t) : "ticker" == e && r.animate(a, speed, "linear", function () {
	          b(s.resetValue, "reset", 0), N();
	        });
	      }
	    },
	        w = function w() {
	      for (var e = "", i = x(), s = 0; i > s; s++) {
	        var n = "";o.settings.buildPager && t.isFunction(o.settings.buildPager) ? (n = o.settings.buildPager(s), o.pagerEl.addClass("bx-custom-pager")) : (n = s + 1, o.pagerEl.addClass("bx-default-pager")), e += '<div class="bx-pager-item"><a href="" data-slide-index="' + s + '" class="bx-pager-link">' + n + "</a></div>";
	      }o.pagerEl.html(e);
	    },
	        T = function T() {
	      o.settings.pagerCustom ? o.pagerEl = t(o.settings.pagerCustom) : (o.pagerEl = t('<div class="bx-pager" />'), o.settings.pagerSelector ? t(o.settings.pagerSelector).html(o.pagerEl) : o.controls.el.addClass("bx-has-pager").append(o.pagerEl), w()), o.pagerEl.on("click", "a", I);
	    },
	        C = function C() {
	      o.controls.next = t('<a class="bx-next" href="">' + o.settings.nextText + "</a>"), o.controls.prev = t('<a class="bx-prev" href="">' + o.settings.prevText + "</a>"), o.controls.next.bind("click", y), o.controls.prev.bind("click", z), o.settings.nextSelector && t(o.settings.nextSelector).append(o.controls.next), o.settings.prevSelector && t(o.settings.prevSelector).append(o.controls.prev), o.settings.nextSelector || o.settings.prevSelector || (o.controls.directionEl = t('<div class="bx-controls-direction" />'), o.controls.directionEl.append(o.controls.prev).append(o.controls.next), o.controls.el.addClass("bx-has-controls-direction").append(o.controls.directionEl));
	    },
	        E = function E() {
	      o.controls.start = t('<div class="bx-controls-auto-item"><a class="bx-start" href="">' + o.settings.startText + "</a></div>"), o.controls.stop = t('<div class="bx-controls-auto-item"><a class="bx-stop" href="">' + o.settings.stopText + "</a></div>"), o.controls.autoEl = t('<div class="bx-controls-auto" />'), o.controls.autoEl.on("click", ".bx-start", k), o.controls.autoEl.on("click", ".bx-stop", M), o.settings.autoControlsCombine ? o.controls.autoEl.append(o.controls.start) : o.controls.autoEl.append(o.controls.start).append(o.controls.stop), o.settings.autoControlsSelector ? t(o.settings.autoControlsSelector).html(o.controls.autoEl) : o.controls.el.addClass("bx-has-controls-auto").append(o.controls.autoEl), A(o.settings.autoStart ? "stop" : "start");
	    },
	        P = function P() {
	      o.children.each(function () {
	        var e = t(this).find("img:first").attr("title");void 0 != e && ("" + e).length && t(this).append('<div class="bx-caption"><span>' + e + "</span></div>");
	      });
	    },
	        y = function y(t) {
	      o.settings.auto && r.stopAuto(), r.goToNextSlide(), t.preventDefault();
	    },
	        z = function z(t) {
	      o.settings.auto && r.stopAuto(), r.goToPrevSlide(), t.preventDefault();
	    },
	        k = function k(t) {
	      r.startAuto(), t.preventDefault();
	    },
	        M = function M(t) {
	      r.stopAuto(), t.preventDefault();
	    },
	        I = function I(e) {
	      o.settings.auto && r.stopAuto();var i = t(e.currentTarget),
	          s = parseInt(i.attr("data-slide-index"));s != o.active.index && r.goToSlide(s), e.preventDefault();
	    },
	        q = function q(e) {
	      var i = o.children.length;return "short" == o.settings.pagerType ? (o.settings.maxSlides > 1 && (i = Math.ceil(o.children.length / o.settings.maxSlides)), o.pagerEl.html(e + 1 + o.settings.pagerShortSeparator + i), void 0) : (o.pagerEl.find("a").removeClass("active"), o.pagerEl.each(function (i, s) {
	        t(s).find("a").eq(e).addClass("active");
	      }), void 0);
	    },
	        D = function D() {
	      if (o.settings.infiniteLoop) {
	        var t = "";0 == o.active.index ? t = o.children.eq(0).position() : o.active.index == x() - 1 && o.carousel ? t = o.children.eq((x() - 1) * m()).position() : o.active.index == o.children.length - 1 && (t = o.children.eq(o.children.length - 1).position()), t && ("horizontal" == o.settings.mode ? b(-t.left, "reset", 0) : "vertical" == o.settings.mode && b(-t.top, "reset", 0));
	      }o.working = !1, o.settings.onSlideAfter(o.children.eq(o.active.index), o.oldIndex, o.active.index);
	    },
	        A = function A(t) {
	      o.settings.autoControlsCombine ? o.controls.autoEl.html(o.controls[t]) : (o.controls.autoEl.find("a").removeClass("active"), o.controls.autoEl.find("a:not(.bx-" + t + ")").addClass("active"));
	    },
	        W = function W() {
	      1 == x() ? (o.controls.prev.addClass("disabled"), o.controls.next.addClass("disabled")) : !o.settings.infiniteLoop && o.settings.hideControlOnEnd && (0 == o.active.index ? (o.controls.prev.addClass("disabled"), o.controls.next.removeClass("disabled")) : o.active.index == x() - 1 ? (o.controls.next.addClass("disabled"), o.controls.prev.removeClass("disabled")) : (o.controls.prev.removeClass("disabled"), o.controls.next.removeClass("disabled")));
	    },
	        H = function H() {
	      o.settings.autoDelay > 0 ? setTimeout(r.startAuto, o.settings.autoDelay) : r.startAuto(), o.settings.autoHover && r.hover(function () {
	        o.interval && (r.stopAuto(!0), o.autoPaused = !0);
	      }, function () {
	        o.autoPaused && (r.startAuto(!0), o.autoPaused = null);
	      });
	    },
	        L = function L() {
	      var e = 0;if ("next" == o.settings.autoDirection) r.append(o.children.clone().addClass("bx-clone"));else {
	        r.prepend(o.children.clone().addClass("bx-clone"));var i = o.children.first().position();e = "horizontal" == o.settings.mode ? -i.left : -i.top;
	      }b(e, "reset", 0), o.settings.pager = !1, o.settings.controls = !1, o.settings.autoControls = !1, o.settings.tickerHover && !o.usingCSS && o.viewport.hover(function () {
	        r.stop();
	      }, function () {
	        var e = 0;o.children.each(function () {
	          e += "horizontal" == o.settings.mode ? t(this).outerWidth(!0) : t(this).outerHeight(!0);
	        });var i = o.settings.speed / e,
	            s = "horizontal" == o.settings.mode ? "left" : "top",
	            n = i * (e - Math.abs(parseInt(r.css(s))));N(n);
	      }), N();
	    },
	        N = function N(t) {
	      speed = t ? t : o.settings.speed;var e = { left: 0, top: 0 },
	          i = { left: 0, top: 0 };"next" == o.settings.autoDirection ? e = r.find(".bx-clone").first().position() : i = o.children.first().position();var s = "horizontal" == o.settings.mode ? -e.left : -e.top,
	          n = "horizontal" == o.settings.mode ? -i.left : -i.top,
	          a = { resetValue: n };b(s, "ticker", speed, a);
	    },
	        O = function O() {
	      o.touch = { start: { x: 0, y: 0 }, end: { x: 0, y: 0 } }, o.viewport.bind("touchstart", X);
	    },
	        X = function X(t) {
	      if (o.working) t.preventDefault();else {
	        o.touch.originalPos = r.position();var e = t.originalEvent;o.touch.start.x = e.changedTouches[0].pageX, o.touch.start.y = e.changedTouches[0].pageY, o.viewport.bind("touchmove", Y), o.viewport.bind("touchend", V);
	      }
	    },
	        Y = function Y(t) {
	      var e = t.originalEvent,
	          i = Math.abs(e.changedTouches[0].pageX - o.touch.start.x),
	          s = Math.abs(e.changedTouches[0].pageY - o.touch.start.y);if (3 * i > s && o.settings.preventDefaultSwipeX ? t.preventDefault() : 3 * s > i && o.settings.preventDefaultSwipeY && t.preventDefault(), "fade" != o.settings.mode && o.settings.oneToOneTouch) {
	        var n = 0;if ("horizontal" == o.settings.mode) {
	          var r = e.changedTouches[0].pageX - o.touch.start.x;n = o.touch.originalPos.left + r;
	        } else {
	          var r = e.changedTouches[0].pageY - o.touch.start.y;n = o.touch.originalPos.top + r;
	        }b(n, "reset", 0);
	      }
	    },
	        V = function V(t) {
	      o.viewport.unbind("touchmove", Y);var e = t.originalEvent,
	          i = 0;if (o.touch.end.x = e.changedTouches[0].pageX, o.touch.end.y = e.changedTouches[0].pageY, "fade" == o.settings.mode) {
	        var s = Math.abs(o.touch.start.x - o.touch.end.x);s >= o.settings.swipeThreshold && (o.touch.start.x > o.touch.end.x ? r.goToNextSlide() : r.goToPrevSlide(), r.stopAuto());
	      } else {
	        var s = 0;"horizontal" == o.settings.mode ? (s = o.touch.end.x - o.touch.start.x, i = o.touch.originalPos.left) : (s = o.touch.end.y - o.touch.start.y, i = o.touch.originalPos.top), !o.settings.infiniteLoop && (0 == o.active.index && s > 0 || o.active.last && 0 > s) ? b(i, "reset", 200) : Math.abs(s) >= o.settings.swipeThreshold ? (0 > s ? r.goToNextSlide() : r.goToPrevSlide(), r.stopAuto()) : b(i, "reset", 200);
	      }o.viewport.unbind("touchend", V);
	    },
	        Z = function Z() {
	      var e = t(window).width(),
	          i = t(window).height();(a != e || l != i) && (a = e, l = i, r.redrawSlider(), o.settings.onSliderResize.call(r, o.active.index));
	    };return r.goToSlide = function (e, i) {
	      if (!o.working && o.active.index != e) if (o.working = !0, o.oldIndex = o.active.index, o.active.index = 0 > e ? x() - 1 : e >= x() ? 0 : e, o.settings.onSlideBefore(o.children.eq(o.active.index), o.oldIndex, o.active.index), "next" == i ? o.settings.onSlideNext(o.children.eq(o.active.index), o.oldIndex, o.active.index) : "prev" == i && o.settings.onSlidePrev(o.children.eq(o.active.index), o.oldIndex, o.active.index), o.active.last = o.active.index >= x() - 1, o.settings.pager && q(o.active.index), o.settings.controls && W(), "fade" == o.settings.mode) o.settings.adaptiveHeight && o.viewport.height() != v() && o.viewport.animate({ height: v() }, o.settings.adaptiveHeightSpeed), o.children.filter(":visible").fadeOut(o.settings.speed).css({ zIndex: 0 }), o.children.eq(o.active.index).css("zIndex", o.settings.slideZIndex + 1).fadeIn(o.settings.speed, function () {
	        t(this).css("zIndex", o.settings.slideZIndex), D();
	      });else {
	        o.settings.adaptiveHeight && o.viewport.height() != v() && o.viewport.animate({ height: v() }, o.settings.adaptiveHeightSpeed);var s = 0,
	            n = { left: 0, top: 0 };if (!o.settings.infiniteLoop && o.carousel && o.active.last) {
	          if ("horizontal" == o.settings.mode) {
	            var a = o.children.eq(o.children.length - 1);n = a.position(), s = o.viewport.width() - a.outerWidth();
	          } else {
	            var l = o.children.length - o.settings.minSlides;n = o.children.eq(l).position();
	          }
	        } else if (o.carousel && o.active.last && "prev" == i) {
	          var d = 1 == o.settings.moveSlides ? o.settings.maxSlides - m() : (x() - 1) * m() - (o.children.length - o.settings.maxSlides),
	              a = r.children(".bx-clone").eq(d);n = a.position();
	        } else if ("next" == i && 0 == o.active.index) n = r.find("> .bx-clone").eq(o.settings.maxSlides).position(), o.active.last = !1;else if (e >= 0) {
	          var c = e * m();n = o.children.eq(c).position();
	        }if ("undefined" != typeof n) {
	          var g = "horizontal" == o.settings.mode ? -(n.left - s) : -n.top;b(g, "slide", o.settings.speed);
	        }
	      }
	    }, r.goToNextSlide = function () {
	      if (o.settings.infiniteLoop || !o.active.last) {
	        var t = parseInt(o.active.index) + 1;r.goToSlide(t, "next");
	      }
	    }, r.goToPrevSlide = function () {
	      if (o.settings.infiniteLoop || 0 != o.active.index) {
	        var t = parseInt(o.active.index) - 1;r.goToSlide(t, "prev");
	      }
	    }, r.startAuto = function (t) {
	      o.interval || (o.interval = setInterval(function () {
	        "next" == o.settings.autoDirection ? r.goToNextSlide() : r.goToPrevSlide();
	      }, o.settings.pause), o.settings.autoControls && 1 != t && A("stop"));
	    }, r.stopAuto = function (t) {
	      o.interval && (clearInterval(o.interval), o.interval = null, o.settings.autoControls && 1 != t && A("start"));
	    }, r.getCurrentSlide = function () {
	      return o.active.index;
	    }, r.getCurrentSlideElement = function () {
	      return o.children.eq(o.active.index);
	    }, r.getSlideCount = function () {
	      return o.children.length;
	    }, r.redrawSlider = function () {
	      o.children.add(r.find(".bx-clone")).outerWidth(u()), o.viewport.css("height", v()), o.settings.ticker || S(), o.active.last && (o.active.index = x() - 1), o.active.index >= x() && (o.active.last = !0), o.settings.pager && !o.settings.pagerCustom && (w(), q(o.active.index));
	    }, r.destroySlider = function () {
	      o.initialized && (o.initialized = !1, t(".bx-clone", this).remove(), o.children.each(function () {
	        void 0 != t(this).data("origStyle") ? t(this).attr("style", t(this).data("origStyle")) : t(this).removeAttr("style");
	      }), void 0 != t(this).data("origStyle") ? this.attr("style", t(this).data("origStyle")) : t(this).removeAttr("style"), t(this).unwrap().unwrap(), o.controls.el && o.controls.el.remove(), o.controls.next && o.controls.next.remove(), o.controls.prev && o.controls.prev.remove(), o.pagerEl && o.settings.controls && o.pagerEl.remove(), t(".bx-caption", this).remove(), o.controls.autoEl && o.controls.autoEl.remove(), clearInterval(o.interval), o.settings.responsive && t(window).unbind("resize", Z));
	    }, r.reloadSlider = function (t) {
	      void 0 != t && (n = t), r.destroySlider(), d();
	    }, d(), this;
	  };
	}(jQuery);

/***/ })
/******/ ]);
